
import { TextValueItem } from "@/models";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  components: {
    MultiSelect: () => import('@/components/shared/MultiSelect.vue')
  }
})
export default class FilterPopup extends Vue {
    @Prop({ default: null }) initialValue!: any;
    @Prop({ default: "string" }) type!: string;
    @Prop({ default: null }) dataSource!: TextValueItem[];
    @Prop({ default: "bottom" }) location!: string;
    @Prop({ default: null }) field!: string;

    showMenu: boolean = false;
    filterText: string = "";
    filterNumber: string = "";
    filterMultiSelect: TextValueItem[] = [];
    multiSelectInitialValue: TextValueItem[] = [];

    operatorSelected: number = 0;

    get numberOperators(): any[] {
        return [
            {
                label: "Uguale a",
                value: 0
            },
            {
                label: "Minore di",
                value: 1
            },
            {
                label: "Minore o uguale a",
                value: 2
            },
            {
                label: "Maggiore di",
                value: 3
            },
            {
                label: "Maggiore o uguale a",
                value: 4
            }
        ];
    }

    get stringOperators(): any[] {
        return [
            {
                label: "Contiene",
                value: 0
            },
            {
                label: "Uguale a",
                value: 1
            },
            {
                label: "Diverso da",
                value: 2
            },
            {
                label: "Comincia per",
                value: 3
            },
            {
                label: "Non contiene",
                value: 4
            },
            {
                label: "Finisce per",
                value: 5
            }
        ];
    }

    get selectOperators(): any[] {
        return [
            {
                label: "Contiene",
                value: 0
            },
            {
                label: "Non contiene",
                value: 1
            }
        ];
    }

    get operators(): any[] {
        if (this.type === "number") {
            return this.numberOperators;
        } else if (this.type === "multiselect") {
            return this.selectOperators;
        } else {
            return this.stringOperators;
        }
    }

    created(): void {
        if (this.initialValue) {
            if (this.type === "string") {
                this.operatorSelected = this.initialValue.operator || 0;
                this.filterText = this.initialValue.filter || "";
            } else if (this.type === "number") {
                this.operatorSelected = this.initialValue.operator || 0;
                this.filterNumber = this.initialValue.filter || null;
            } else if (this.type === "multiselect") {
                this.operatorSelected = this.initialValue.operator || 0;
                if(this.initialValue.filter && this.initialValue.filter.length){
                    this.filterMultiSelect = this.dataSource.filter(obj => (this.initialValue.filter as string[]).includes( obj.value )); 
                    this.multiSelectInitialValue = this.filterMultiSelect;
                }
            }
        }
    }

    onSaveFilter() {
        var objFilter: any;
        if (this.type === "number") {
            objFilter = { field: this.field, operator: this.operatorSelected, filter: parseFloat(this.filterNumber) };
        } else if (this.type === "multiselect") {
            var f : String[] = [];
            if(this.filterMultiSelect && this.filterMultiSelect.length){
                f = this.filterMultiSelect.map(obj => obj.value);
            }
            objFilter = { field: this.field, operator: this.operatorSelected, filter: f };
        } else {
            objFilter = { field: this.field, operator: this.operatorSelected, filter: this.filterText };
        }
        this.$emit("setFilter", objFilter);
        this.showMenu = false;
    }

    onRemoveFilter() {
        this.filterText = "";
        this.filterNumber = "";
        this.filterMultiSelect = [];
        this.operatorSelected = 0;
        this.$emit("removeFilter", { field: this.field });
        this.showMenu = false;
    }

    
    onSelectChange(newVal : TextValueItem[]) {
        this.filterMultiSelect = newVal || [];;
    }
}
